import React, { useEffect, useState } from 'react'
import NavBar from '../NavBar/NavBar'
import "./Blogs.css"
import { Helmet } from 'react-helmet-async';
import "./Blogs.css"
import { Link } from 'react-router-dom';
import Footer from '../Footer/Footer';
import { useGetBlogQuery } from '../../Redux/Api/AuthApi';


const Blogs = () => {
  const [allData,setAllData] = useState()


  const {data,isSuccess} = useGetBlogQuery()

  console.log(data)

  useEffect(()=>{
    if(isSuccess){
      setAllData(data)
    }
  },[isSuccess,setAllData,data])
  return (
    <>
    <Helmet>
     <title>Blogs</title>
     <meta
     name="description"
     content=" 
    "/>
    <link rel="canonical" href="/"/>
    </Helmet> 
    <div className='kiga-blogs-main'>
     <NavBar />
     {/* Hero Section */}
     <section 
        className='about-hero'
        style={{
        background: `linear-gradient(135deg, rgba(0,0,0,0.75), rgba(0,0,0,0.6)), url('/images/moving2.jpg')`,
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
        }}
    >
        <div className='about-hero-content'>
        <div className='about-hero-text'>
            <span className='hero-subtitle animate-slide-up'>Welcome to</span>
            <h1 className='animate-slide-up-delay'>
            Kigali International <span>Gymnastics Academy</span>
            </h1>
            <div className='hero-breadcrumb animate-slide-up-delay-2'>
            <Link to="/">Home</Link>
            <span>/</span>
            <span className='current'>News</span>
            </div>
        </div>
        </div>
        <div className='hero-wave'>
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z" />
        </svg>
        </div>
     </section>
     <section className='kiga-blogs-main-section'>
        {
          allData?.map((el,index)=>(
        <div className="kiga-blogs-main-section-card" key={index}>
        {/* Image */}
        <div className="kiga-blogs-main-section-card-image">
            <img src={el?.image} alt={el?.title} />
            {el?.category && (
            <span className="blog-card-category">{el?.category}</span>
            )}
        </div>

        {/* Content */}
        <div className="kiga-blogs-main-section-card-content">
            <h3 className="kiga-blogs-main-section-card-title">{el?.title}</h3>
            {/* Author & Meta */}
            <div className="kiga-blogs-main-section-card-meta">
            <div className="kiga-blogs-main-section-card-author">
                <img src={el?.author?.avatar} alt={el?.author?.name} />
                <div>
                <p className="kiga-blogs-main-section-card-author-name">{el?.author.name}</p>
                <p className="kiga-blogs-main-section-card-post-date">{el?.date}</p>
                </div>
            </div>

            {el?.readTime && (
                <span className="read-time">{el?.readTime}</span>
            )}
            </div>
            <p className="kiga-blogs-main-section-card-excerpt">{el?.excerpt}</p>
        </div>

        {/* Footer */}
        <div className="kiga-blogs-main-section-card-footer">
            <a href={el?.slug} className="kiga-blogs-main-section-card-read-more">
            Read More →
            </a>
        </div>
        </div>
          ))
        }
     </section>
     <Footer/>
    </div>
    </>
  )
}

export default Blogs